let users = {
  title: 'Profissionais',
  title_s: 'Profissional',
  icon: 'mdi-account-multiple',
  datatable: {
    search: 'Pesquisa',
    no_data: 'Nenhum profissional cadastrado',
    no_results: 'Nenhum resultado encontrado',
    items_per_page: 'Profissionais por página',
    headers: {
      id: 'ID',
      name: 'Nome',
      login: 'Login',
      function: 'Permissão',
      category: 'Categorias',
      all: 'Todas',
      all_category: 'Categorias: Todas',
      action: 'Ações',
      history: 'Histórico'
    }
  },
  actions: {
    view: 'Ver',
    edit: 'Editar',
    save: 'Salvar',
    delete: 'Excluir'
  },
  view: {
    user: 'Profissional',
    history: {
      created: 'Criado',
      edited: 'Editado',
      unknown: 'Desconhecido'
    }
  },
  status: {
    idle: 'Vago',
    active: 'Ativo',
    absent: 'Ausente'
  },
  new: {
    title: 'Novo Profissional',
    no_cat: 'Nenhuma Categoria',
    rules: {
      passRules: [
        v => !!v || 'Senha é obrigatória',
        v => (v && v.length >= 7) || 'A Senha deve ter pelo menos 7 caracteres',
        v => (v && v.length <= 27) || 'A Senha deve ter menos que 27 caracteres'
      ],
      functionRules: [
        v => !!v || 'Função é obrigatória'
      ]
    },
    validate: {
      error: {
        login_exist: 'Login já cadastrado',
        pass_match: 'As Senhas não coincidem'
      }
    }
  },
  edit: {
    title: 'Editar Profissional',
    newpass: 'Nova Senha',
    newpass_confirm: 'Confirma Nova Senha',
    rules: {
      nameRules: [
        v => !!v || 'Nome é obrigatório',
        v => (v && v.length <= 27) || 'O Nome deve ter menos que 27 caracteres'
      ],
      loginRules: [
        v => !!v || 'Login é obrigatório',
        v => (v && v.length >= 5) || 'O Login deve ter pelo menos 5 caracteres',
        v => (v && v.length <= 20) || 'O Login deve ter menos que 20 caracteres'
      ],
      passRules: [
        v => (!v || v.length >= 7) || 'A Senha deve ter pelo menos 7 caracteres',
        v => (!v || v.length <= 27) || 'A Senha deve ter menos que 27 caracteres'
      ]
    }
  },
  dialog: {
    deleteConfirm: 'Tem certeza que deseja excluir o Profissional'
  },
  messages: {
    error: {
      not_found: 'Profissional não encontrado'
    }
  }
}

export default users
